import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BaseApi } from 'sustainment-component';
import { IResourceResponseModel } from '../store/resources/resources.model';

@Injectable()
export class EdcAPI extends BaseApi {
  protected urlBase: string;
  public constructor(httpClient: HttpClient) {
    super(httpClient);
    this.urlBase = environment.mediaApiBaseUrl;
  }

  public getResourceData(state: string): Observable<IResourceResponseModel[]> {
    return this._http.get<IResourceResponseModel[]>(
      `${this.urlBase}edc/resources?state=${state}`
    );
  }
}
